/* eslint-disable */

const passwordValidator = require("password-validator");

export function validatePassword(pwd) {
	
	const schema = new passwordValidator();
	schema
		.is().min(8)                                   // Minimum length 8
		.is().max(100)                                  // Maximum length 100
		.has().uppercase()                              // Must have uppercase letters
		.has().lowercase()                              // Must have lowercase letters
		.has().digits(1)                                // Must have at least 2 digits
		.has().not().spaces()                           // Should not have spaces
		.is().not().oneOf(['password', 'test1234','1234567890','admin']); // Blacklist these values
	
	return (
		schema.validate(pwd)
	)
}

export function isEmail(val) {
	let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if (!regEmail.test(val)) {
		return false;
	}
	return true;
}

export function isPhone(val) {
	// let rePhone = /^(\(0\d\)\d{7}|\(02\d\)\d{6,8}|0800\s\d{5,8})$/;
	let valNew = String(val).replace(/null/g,'');
	valNew = String(valNew).replace(/\s/g,'');
	valNew = String(valNew).replace(/-/g,'');
	valNew = String(valNew).replace(/\(/g,'');
	valNew = String(valNew).replace(/\)/g,'').trim();
	let rePhone = /^(((\+64\s*[-\.]?[3-9]|\(?0[3-9]\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{4})|((\+?64\s*[-\.\(]?2\d{1}[-\.\)]?|\(?02\d{1}\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{3,5})|((\+?64\s*[-\.]?[-\.\(]?800[-\.\)]?|[-\.\(]?0508[-\.\)]?|[-\.\(]?0800[-\.\)]?)\s*[-\.]?\d{3}\s*[-\.]?(\d{3,4}|\d{6,7})))$/;
	if (!rePhone.test(val) && val !== '') {
		return false;
	}
	return true;
}